import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChromecast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChromecast"><Path d="M2 3V7C9.73199 7 16 13.268 16 21H22V3H2Z" fill="currentColor"/><Path d="M2 14.75C5.45178 14.75 8.25 17.5482 8.25 21H9.75C9.75 16.7198 6.28021 13.25 2 13.25V14.75Z" fill="currentColor"/><Path d="M12.25 21C12.25 15.3391 7.66092 10.75 2 10.75V9.25C8.48935 9.25 13.75 14.5107 13.75 21H12.25Z" fill="currentColor"/><Path d="M2 18.75C3.24264 18.75 4.25 19.7574 4.25 21H5.75C5.75 18.9289 4.07107 17.25 2 17.25V18.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChromecast;
